mutation AddPushSubscriptionMutation($input: AddPushSubscriptionInput!) {
  addPushSubscription(input: $input)
}